import { useFormikContext } from "formik";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import BasicSelect from "components/BasicInputs/BasicSelect";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { apiProductsList } from "api/productApi";
import { apiGetProjects } from "api/projectApi";
import { apiGetBranches } from "api/branchApi";
import { apiGetManufactureFormulas } from "api/manufactureFormulaApi";
import { useMemo } from "react";
import useResponsive from "helpers/useResponsive";
import shortid from "shortid";
import { apiFinancialsList } from "api/financialApi";
import { getInitialRows } from "../utils";

export default function Info() {
  const dispatch = useAppDispatch();
  const store = useAppSelector((x: any) => x);
  const token = store.businessReducer.business.token;
  const { values, setFieldValue } = useFormikContext<MaterialOrderData>();
  const { isMobile } = useResponsive();

  const formulaOptions = useMemo(() => {
    if (values.productId === undefined)
      return store.manufactureFormulaReducer.formulas?.map((item: ManufactureFormula) => {
        return { ...item, label: item.accountingCode + " - " + item.title };
      });
    const filteredFormulas: any = [];
    store.manufactureFormulaReducer.formulas?.forEach((formula: ManufactureFormula) => {
      if (formula.ProductId === values.productId) {
        filteredFormulas.push({ ...formula, label: formula.accountingCode + " - " + formula.title });
      }
    });
    return filteredFormulas;
  }, [values.productId, store.manufactureFormulaReducer.formulas]);
  return (
    <div className={`flex flex-col gap-12 py-11 ${isMobile && "px-3"}`}>
      <div className="flex flex-wrap justify-between gap-12">
        <div className="flex flex-col w-full gap-12 md:w-96">
          <BasicSelect
            options={store.productReducer.allProducts}
            label="انتخاب محصول"
            required
            withSearch
            withRefresh
            withClear
            defaultValue={values.productId}
            refreshList={() => dispatch(apiProductsList({ token }))}
            onChange={(val, option: Product) => {
              setFieldValue("productId", val);
              setFieldValue("product", option);
              setFieldValue("quantityUnit", option.unit);
              setFieldValue(
                "quantityUnits",
                [option.unit].flatMap((x) => (option.subUnit ? [x, option.subUnit] : [x]))
              );

              if (values.formulaId !== undefined) {
                setFieldValue("formulaId", undefined);
                setFieldValue("formula", undefined);
                setFieldValue("materialsRows", getInitialRows());
              }
            }}
            onClear={() => {
              setFieldValue("productId", undefined);
              setFieldValue("product", undefined);
              setFieldValue("quantityUnit", undefined);
              setFieldValue("quantityUnits", undefined);
              setFieldValue("formulaId", undefined);
              setFieldValue("formula", undefined);
              setFieldValue("materialsRows", getInitialRows());
            }}
          />
        </div>
        <div className="flex flex-col w-full gap-12 md:w-96">
          <div className="flex flex-col justify-between gap-6 md:flex-row">
            <BasicSelect
              options={formulaOptions}
              label="انتخاب فرمول تولید"
              containerStyle={{ width: "100%" }}
              required
              withSearch
              withRefresh
              withClear
              valKey="id"
              defaultValue={values.formulaId}
              refreshList={() => dispatch(apiGetManufactureFormulas({ token }))}
              onChange={(val, option: ManufactureFormula) => {
                if (values.productId === undefined) {
                  setFieldValue("productId", option.ProductId);
                  setFieldValue("product", option.Product);
                  setFieldValue("quantityUnit", option.Product.unit);
                  setFieldValue(
                    "quantityUnits",
                    [option.Product.unit].flatMap((x) =>
                      option.Product.subUnit ? [x, option.Product.subUnit] : [x]
                    )
                  );
                }
                setFieldValue("formulaId", val);
                setFieldValue("formula", option);
                setFieldValue("wages", [
                  {
                    ind: shortid.generate(),
                    type: option.estimateWageType,
                    value: option.estimateWage,
                    amount: 0,
                    isCreditor: false,
                    label: "wage",
                  },
                ]);
                setFieldValue("costs", [
                  {
                    ind: shortid.generate(),
                    type: option.estimateCostType,
                    value: option.estimateCost,
                    amount: 0,
                    isCreditor: false,
                    label: "cost",
                  },
                ]);

                const newRows: MaterialOrderRow[] = [];
                option.Production_Formula_Items.forEach((item) => {
                  const buyPrice = item.Product.buyPrice || 0;
                  let totalPrice = item.quantity * buyPrice;
                  newRows.push({
                    ind: shortid.generate(),
                    ProductId: item.ProductId,
                    Product: item.Product,
                    quantity: item.quantity,
                    unitPrice: item.Product.buyPrice || 0,
                    unit: item.Product.unit,
                    subUnit: item.Product.subUnit,
                    selectedUnit: item.Product.unit,
                    conversionRatio: item.Product.conversionRatio,
                    totalPrice: totalPrice,
                  });
                });
                setFieldValue("materialsRows", newRows);
              }}
              onClear={() => {
                setFieldValue("formulaId", undefined);
                setFieldValue("formula", undefined);
              }}
            />
            <BasicTextInput
              type="quantity"
              label="مقدار سفارش"
              required
              style={{ padding: "0px 12px 0px 0px" }}
              val={Number(values.quantity)}
              arrowHidden
              min={1}
              onChange={(val) => setFieldValue("quantity", Number(val))}
              prefix={
                <div className="w-24 my-2 border-r border-gray-200">
                  <BasicSelect
                    containerStyle={{ minWidth: 60 }}
                    menuStyle={{ minWidth: 60 }}
                    disabled={values.productId === undefined}
                    btnStyle={{ border: "none", minWidth: 60 }}
                    defaultValue={values.quantityUnit}
                    onChange={(val) => setFieldValue("quantityUnit", val)}
                    options={values.quantityUnits?.map((x: any) => ({ label: x, value: x }))}
                  />
                </div>
              }
            />
          </div>
        </div>
      </div>
      <div className="flex flex-wrap justify-between gap-12">
        <div className="flex flex-col w-full gap-12 md:w-96">
          {/*<BasicSelect*/}
          {/*  options={store.financialReducer.banks}*/}
          {/*  label="بانک"*/}
          {/*  withSearch*/}
          {/*  required*/}
          {/*  withRefresh*/}
          {/*  withClear*/}
          {/*  defaultValue={values.optionableId}*/}
          {/*  refreshList={() => dispatch(apiFinancialsList("bank", token))}*/}
          {/*  onChange={(val, option: Person | Finance) => {*/}
          {/*    setFieldValue("optionableType", "financial");*/}
          {/*    setFieldValue("optionableId", val);*/}
          {/*    setFieldValue("optionable", option);*/}
          {/*  }}*/}
          {/*  onClear={() => {*/}
          {/*    setFieldValue("optionableType", undefined);*/}
          {/*    setFieldValue("optionableId", undefined);*/}
          {/*    setFieldValue("optionable", undefined);*/}
          {/*  }}*/}
          {/*/>*/}
          <BasicTextInput
            label="شرح تولید"
            val={values.description}
            onChange={(val) => setFieldValue("description", val)}
          />
        </div>
        <div className="flex flex-col w-full gap-12 md:w-96">
          <div className="flex flex-col justify-between gap-6 md:flex-row">
            <BasicSelect
              options={store.projectReducer.projects}
              label="پروژه"
              withSearch
              containerStyle={{ width: "100%" }}
              withRefresh
              withClear
              defaultValue={values.projectId}
              refreshList={() => dispatch(apiGetProjects(token))}
              onChange={(val, option: Project) => {
                setFieldValue("projectId", val);
                setFieldValue("project", option);
              }}
              onClear={() => {
                setFieldValue("projectId", undefined);
                setFieldValue("project", undefined);
              }}
            />
            <BasicSelect
              options={store.branchReducer.branches}
              label="شعبه"
              withSearch
              containerStyle={{ width: "100%" }}
              withRefresh
              withClear
              defaultValue={values.branchId}
              refreshList={() => dispatch(apiGetBranches(token))}
              onChange={(val, option: Branch) => {
                setFieldValue("branchId", val);
                setFieldValue("branch", option);
              }}
              onClear={() => {
                setFieldValue("branchId", undefined);
                setFieldValue("branch", undefined);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
